import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import NestedPropertyUtil from '@/utils/nestedProperty';

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
// import '@/libs/acl'
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";
import Print from "vue-print-nb";

// Axios Mock Adapter
import "@/@fake-db/db";

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(Print);
Vue.use(NestedPropertyUtil);

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;
import { mapGetters, mapActions, mapMutations } from "vuex";

var mixin = {
  data() {
    return {
      baseUrl: "",
    };
  },
  computed: {
    ...mapGetters([
      "all_data",
      "all_response",
      "createResponse",
      "names",
      "listDepartments",
      "ListJobTitles",
      "listDiseaseCategories",
      "listDiseaseSubcategories",
      "listDiseaseitems",
      "prognosis",
    ]),
    getUserInfo() {
      return JSON.parse(localStorage.getItem("userData")) || false;
    },
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
      "checkAuth",
      "getList",
      "getListNames",
      "clearCache",
      "getListDepartments",
      "getListJobTitles",
      "getListDiseaseCategories",
      "getListDiseaseSubcategories",
      "getListDiseaseitems",
      "create",
      "update",
      "delete",
      "getPatient",
      "getPrognosis",
    ]),
  },
};

Vue.mixin(mixin);
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
